export const FOLDERS = 'folders'
